<template>
    <nav-list v-if="socialComputed" :nav="socialComputed" :_class="'-circle -border-main'" />
</template>

<script>
    import NavList from '@/Components/NavList'

    export default {
        components: {
            NavList,
        },

        props: {
            user: {
                type: Object,
                require: true,
                default() {
                    return {}
                },
            },
        },

        data() {
            return {}
        },

        computed: {
            status() {
                return this.user ? true : false
            },

            socialComputed() {
                return this.user && this.user.social ? this.user.social : null
            },
        },
    }
</script>

<style lang="stylus"></style>
